import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import ExternalLink from 'core/components/ExternalLink'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import Button from 'pf9-ui-components/built/elements/button/Button'
import Modal from 'pf9-ui-components/built/elements/modal/Modal'
import React from 'react'

interface StepContent {
  id: number
  text: React.ReactNode
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    gap: 16,
    alignItems: 'center',
  },
  circle: {
    color: theme.components.card.passiveText,
    background: theme.components.badge.unknown.background,
    border: `1px solid ${theme.components.card.border}`,
    width: 20,
    height: 20,
    borderRadius: 12,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

interface Props {
  onClose: () => void
  open: boolean
  title?: string
  linkUrl?: string
  className?: string
  steps?: StepContent[]
  unhealthyMessage?: React.ReactNode
  warningMessageTitle?: string
  serviceName?: string
  maxWidth?: number
  combinedServiceState?: boolean
}

const TroubleShootModal = ({
  onClose,
  open,
  className,
  linkUrl,
  title = 'Troubleshoot',
  steps = [],
  unhealthyMessage,
  serviceName,
  warningMessageTitle,
  maxWidth = 600,
  combinedServiceState,
}: Props) => {
  const classes = useStyles({})

  return (
    <Modal
      title={title}
      open={open}
      onClose={onClose}
      panel="dialog"
      maxWidth={maxWidth}
      footer={<Button onClick={onClose}>Close</Button>}
    >
      {!steps.length ? (
        <Text variant="body2">
          {unhealthyMessage || (
            <>
              The {serviceName} running on {combinedServiceState ? 'one of the nodes' : 'this node'}{' '}
              appears unhealthy. Read{' '}
              <ExternalLink textVariant="body2" url={linkUrl}>
                here
              </ExternalLink>{' '}
              for more info on how to debug this.
            </>
          )}
        </Text>
      ) : (
        <>
          {warningMessageTitle && <Text variant="body2">{warningMessageTitle}</Text>}

          <div className={clsx(classes.container, className)}>
            {steps.map(({ id, text }) => (
              <React.Fragment key={id}>
                {steps.length > 1 && (
                  <Text variant="caption1" className={classes.circle}>
                    {id}
                  </Text>
                )}
                <Text variant="caption1">{text}</Text>
              </React.Fragment>
            ))}
          </div>
        </>
      )}
    </Modal>
  )
}

export default TroubleShootModal
